module.exports = __webpack_public_path__ + "static/media/Atman Aquarium Product Catalogue.4e478531.pdf";